import { Api } from "../../Api";
import { DependencyContainer } from "../../DependencyContainer";
import { ControllerConfigurationService } from "../Controller/ControllerConfigurationService";
import { IControllerConfigurationService } from "../Controller/IControllerConfigurationService";
import { ILoggerService } from "../Logging/ILoggerService";
import { LoggerService } from "../Logging/LoggerService";
import { IWebApiCacheService } from "../WebApi/IWebApiCacheService";
import { WebApiCacheService } from "../WebApi/WebApiCacheService";
import {  ManuallyPairedDevice } from "./IDevice";
import { IManuallyPairedDevicesProtocolService } from "./IManuallyPairedDevicesProtocolService";
import { IManuallyPairedDevicesService } from "./IManuallyPairedDevicesService";
import { DeviceTaskExecutionResult } from "./TaskExecutionResult";

export class ManuallyPairedDevicesService implements IManuallyPairedDevicesService {

    public static readonly ServiceName = "ManualDeviceService";
    private _manualDeviceProtocolServices: Map<string, IManuallyPairedDevicesProtocolService> = new Map();

    GetServiceName(): string {
        return ManuallyPairedDevicesService.ServiceName;
    }

    RegisterManuallyPairedDevicesProtocol(service: IManuallyPairedDevicesProtocolService): void {
        DependencyContainer.Log?.Debug(ManuallyPairedDevicesService.ServiceName, `Registering new manual device protocol service: ${service.GetServiceName()}`);
        this._manualDeviceProtocolServices.set(service.GetServiceName(), service);
    }

    GetDevicesForManualPairingAsync(protocolGuid?: string | undefined, reloadProtocols?: boolean | undefined): Promise<ManuallyPairedDevice[]>;
    GetDevicesForManualPairingAsync(protocolGuids?: string[] | undefined, reloadProtocols?: boolean | undefined): Promise<ManuallyPairedDevice[]>;
    async GetDevicesForManualPairingAsync(guids?: unknown): Promise<ManuallyPairedDevice[]> {
        const protocolServices = [...this._manualDeviceProtocolServices.values()];
        const result: ManuallyPairedDevice[] = [];

        if (guids != null) {
            if (Array.isArray(guids)) {
                for (let i = 0; i < protocolServices.length; i++) {
                    if (guids.any(extGuid => extGuid == protocolServices[i].ProtocolExtensionGuid))
                        result.push(...(await protocolServices[i].GetDevicesForManualPairingAsync()));
                }
            }
            else {
                const service = protocolServices.find(serv => serv.ProtocolExtensionGuid == guids);

                if (service != null)
                    result.push(...(await service.GetDevicesForManualPairingAsync()));
            }
        }
        else {
            for (let i = 0; i < protocolServices.length; i++) {
                    result.push(...(await protocolServices[i].GetDevicesForManualPairingAsync()));
            }
        }
        return result;
    }

    async AddManuallyPairedDeviceAsync(device: ManuallyPairedDevice): Promise<DeviceTaskExecutionResult> {
        const protocols = [...this._manualDeviceProtocolServices.values()];
        const service = protocols.find(serv => serv.ProtocolExtensionGuid == device.ProtocolExtensionGuid);

        if(service != null)
            return service.AddManuallyPairedDeviceAsync(device);
            
        DependencyContainer.Log?.Error(ManuallyPairedDevicesService.ServiceName, `EXIT CONFIGURATION MODE WILL BE FIRED! AddManuallyPairedDeviceAsync()`);
        Api.Get<IControllerConfigurationService>(ControllerConfigurationService.ServiceName).ExitConfigurationModeAsync();
        return DeviceTaskExecutionResult.Failed;
    }

    GetRegisteredProtocolGuids(): string[] {
        return [...this._manualDeviceProtocolServices.values()].map(e=>e.ProtocolExtensionGuid);
    }
}